import {
	SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledMainContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_300};
`;

export const StyledErrorContainer = styled.div`
	display: flex;
	gap: ${SYS_SPACE_FIXED_150};
	padding: ${SYS_SPACE_FIXED_200} 0;

	svg {
		color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};
	}
`;

export const PriceSectionStyles = styled.div`
	display: grid;
	row-gap: 0.5rem;
	column-gap: 4rem;
	grid-template-columns: 1fr;
	margin: -${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200} 0 ${SYS_SPACE_FIXED_200};

	${breakPoints({
		'768': `
			grid-template-columns: auto auto;
		`,
	})}
	& .summary__price-headline,
	& .summary__price-value {
		display: flex;
		grid-column: 1;
	}

	& .summary__price-value {
		grid-column: 1;
		text-align: left;

		${breakPoints({
			'768': `
				justify-content: flex-end;
				grid-column: 2;
				text-align: right;
			`,
		})}
	}

	& .summary__omnibus-container {
		grid-column: 1 / -1;
		text-align: right;
		display: flex;

		button {
			display: flex;
			align-items: center;
			text-decoration: none;
		}

		${breakPoints({
			'375': `
				margin-left: auto;
			`,
		})}
	}

	p {
		color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK};
	}
`;

export const ButtonSectionStyles = styled.div`
	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
	gap: ${SYS_SPACE_FIXED_150};

	${breakPoints({
		'768': `
			flex-direction: row;
		`,
	})}
`;
